import { configInputConverter } from '@seu-converter';
import {
  SeuApiConverter,
  SeuComponent,
  SeuComponentApi,
  SeuComponentBase,
  SeuComponentBaseApi,
} from '@seu-types';

export const componentConverter: SeuApiConverter<
  SeuComponent,
  SeuComponentApi
> = {
  fromApi: (input) => {
    return {
      ...input,
      id: String(input.id),
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.fromApi(configInput);
      }),
    };
  },
  toApi: (input) => {
    return {
      ...input,
      id: Number(input.id),
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.toApi(configInput);
      }),
    };
  },
};

export const componentBaseConverter: SeuApiConverter<
  SeuComponentBase,
  SeuComponentBaseApi
> = {
  fromApi: (input) => {
    return {
      ...input,
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.fromApi(configInput);
      }),
    };
  },
  toApi: (input) => {
    return {
      ...input,
      inputs: input.inputs.map((configInput) => {
        return configInputConverter.toApi(configInput);
      }),
    };
  },
};
